var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo2Svg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #322920;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M520.96,688.46h-255.6c-11.51,0-20.84-9.33-20.84-20.84v-340.8c0-11.51,9.33-20.84,20.84-20.84h255.6c11.51,0,20.84,9.33,20.84,20.84v2.32h36.12v-31.02c0-37.59-30.47-68.07-68.07-68.07h-240.78c-37.59,0-68.07,30.47-68.07,68.07v403.77c0,37.59,30.47,68.07,68.07,68.07h240.78c37.59,0,68.07-30.47,68.07-68.07v-13.43h-56.95ZM474.5,262c5.5,0,9.96,4.46,9.96,9.96s-4.46,9.96-9.96,9.96-9.96-4.46-9.96-9.96,4.46-9.96,9.96-9.96ZM340.84,265.7h91.68c3.32,0,6.02,2.7,6.02,6.02s-2.7,6.02-6.02,6.02h-91.68c-3.32,0-6.02-2.7-6.02-6.02s2.7-6.02,6.02-6.02ZM393.16,753.28c-14.32,0-25.93-11.61-25.93-25.93s11.61-25.93,25.93-25.93,25.93,11.61,25.93,25.93-11.61,25.93-25.93,25.93Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 389.46,
    cy: 443.51,
    r: 48.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 320,
    y: 500,
    width: 138.91,
    height: 165.46,
    rx: 8.81,
    ry: 8.81
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 550.52,
    cy: 406.47,
    r: 48.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 478.67,
    y: 468.74,
    width: 143.7,
    height: 196.71,
    rx: 9.81,
    ry: 9.81
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 720.53,
    cy: 389.8,
    r: 48.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 642.06,
    y: 450.61,
    width: 156.94,
    height: 214.85,
    rx: 9.81,
    ry: 9.81
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2Svg);
export default __webpack_public_path__ + "static/media/Logo 2 (SVG).27cee58a4ca1514a225c3bb193839956.svg";
export { ForwardRef as ReactComponent };